import styled from 'styled-components'

import {
  _M_Normal,
  _S_Normal,
  Circle,
  mainColors,
  rgba,
  shadowColors,
} from '@avantstay/backoffice-core'

export const SwitchContainer = styled.div`
  ${_M_Normal};
  border-top: 1px solid ${mainColors.neutralMedium};
  padding-top: 14px;
  display: flex;
  gap: 8px;
  margin-top: 10px;
`

export const QuotesSelectionWrapper = styled.div`
  box-shadow: 0 4px 16px 0 ${rgba(shadowColors.blur, 0.4)};
  background-color: ${mainColors.white};
  border: 1px solid ${mainColors.neutralMedium};
  border-radius: 4px;
  padding: 10px;
  display: flex;
  margin-right: 6px;
  max-height: 36px;

  > * {
    &:not(:first-child) {
      &:before {
        content: '';
        width: 1px;
        height: 100%;
        background-color: ${mainColors.neutralDark};
        margin: 0 10px;
      }
    }
  }
`

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    min-width: 15px;
    min-height: 15px;
    width: max-content;

    ${Circle} {
      min-width: 2px;
      min-height: 2px;
      color: ${mainColors.accentMedium};
    }
  }
`

export const SelectedHomes = styled.div`
  color: ${mainColors.neutralExtremelyDark};
  ${_S_Normal};
`
